import { useMemo, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ThemeProvider } from "@mui/material/styles";
import TableWidget from "../Component/Table/TableWidget";
import theme from "../assets/Table/TableTheme";
import { Button, Flex } from "@chakra-ui/react";
import { FaArrowCircleRight } from "react-icons/fa";

function SalesDetails({ details = [], handleBack }) {
    const { t } = useTranslation();

    const columns = useMemo(() => [
        {
            name: "ITEM_NAME",
            label: t("ITEM_NAME"),
            options: { filter: false, sort: false },
        },
        {
            name: "QTY",
            label: t("QTY"),
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) => value?.toLocaleString() || "0",
            },
        },
        {
            name: "SELL",
            label: t("SELL"),
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) => value?.toLocaleString() || "0",
            },
        },
        {
            name: "TOTAL",
            label: t("TOT_SALES"),
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) => value?.toLocaleString() || "0",
            },
        },
    ], [t]);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchText, setSearchText] = useState("");
    const [searchColumns, setSearchColumns] = useState(() =>
        columns.filter((c) => c.options?.search !== false).map((c) => c.name)
    );

    useEffect(() => {
        setSearchColumns(
            columns.filter((c) => c.options?.search !== false).map((c) => c.name)
        );
    }, [columns]);

    const filteredData = details.filter((row) => {
        const search = searchText.toLowerCase();
        return Object.values(row).some((value) =>
            value?.toString().toLowerCase().includes(search)
        );
    });

    return (
        <ThemeProvider theme={theme}>
            <div className="Total_Header_Without_Bg">

                <Flex justify="flex-start" mb={5}>
                    <Button
                        leftIcon={<FaArrowCircleRight />}
                        size="md"
                        borderRadius="full"
                        px={6}
                        onClick={handleBack}
                        className="Back_Icon_Button"
                    >
                    </Button>
                </Flex>

                <TableWidget
                    title={t("INVOICE_DETAILS")}
                    serverSide={false}
                    data={filteredData}
                    onSearchChange={setSearchText}
                    columns={columns}
                    totalCount={filteredData.length}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    onPageChange={setPage}
                    onRowsPerPageChange={setRowsPerPage}
                    searchColumns={searchColumns}
                    setSearchColumns={setSearchColumns}
                />
            </div>
        </ThemeProvider>
    );
}

export default SalesDetails;
